<template>
    <div class="errors" v-for="(error,index) in this.errors" :key="index">
        {{error}}
    </div>
</template>

<script>
export default {
    name: "ErrorsComponent",
    data: () => {
        return {
            errors: [],
        }
    },
    beforeMount() {
        this.$myApp.errors.on((value)=> {
            this.errors = value;
        });
    }
}
</script>